import Logger from '@/lib/logger';
import { NEXT_PUBLIC_HUBSPOT_LOGGING_ENABLED } from '@/lib/env';

const logger = new Logger('HubSpot', 'DEBUG');

if (NEXT_PUBLIC_HUBSPOT_LOGGING_ENABLED) {
  logger.enable();
}

export default logger;
